import React from 'react';
import { Col, Nav, Row, Tab } from 'react-bootstrap';
import "./Product_details_tab.css";

function Product_details_tab({ details }) {
  return (
    <section className='Product_details_tab'>
      <Tab.Container defaultActiveKey="first">
        <Row>
          <Col sm={12}>
            <Nav variant="pills">
              <Nav.Item><Nav.Link eventKey="first">Description</Nav.Link></Nav.Item>
              <Nav.Item><Nav.Link eventKey="second">Highlights</Nav.Link></Nav.Item>
              <Nav.Item><Nav.Link eventKey="third">Packaging</Nav.Link></Nav.Item>
            </Nav>
          </Col>
          <Col sm={12}>
            <Tab.Content>
              <Tab.Pane eventKey="first">
                <p>{details.description}</p>
              </Tab.Pane>
              <Tab.Pane eventKey="second">
                <div className='table_content_holder'>

                  <div className="row">
                    <div className="col-md-6">
                      {details.highlights.map((item, i) => (
                        <div className="row mb-2" key={i}>
                          <div className="col-md-6"><p><strong>{item.label}</strong></p></div>
                          <div className="col-md-6"><p>{item.value}</p></div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </Tab.Pane>
              <Tab.Pane eventKey="third">
                <p>{details.packaging}</p>
              </Tab.Pane>
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </section>
  );
}

export default Product_details_tab;
